import Screen1 from '../../assets/v6/Android Models/QSRDMB155_v6.glb'
import Screen1iOS from '../../assets/v6/iOS Models/QSRDMB155_v6.usdz'
import Screen1Png from '../../assets/v6/PNGs/QSRDMB155_v6.png'

import Screen2 from '../../assets/v6/Android Models/QSRDMB255_v6.glb'
import Screen2Png from '../../assets/v6/PNGs/QSRDMB255_v6.png'
import Screen2iOS from '../../assets/v6/iOS Models/QSRDMB255_v6.usdz'

import Screen3 from '../../assets/v6/Android Models/QSRDMB355_v6.glb'
import Screen3Png from '../../assets/v6/PNGs/QSRDMB355_v6.png'
import Screen3iOS from '../../assets/v6/iOS Models/QSRDMB355_v6.usdz'

import Canopy1Screen from '../../assets/v6/Android Models/canopy 1 screen_v6.glb'
import Canopy1ScreenPng from '../../assets/v6/PNGs/canopy 1 screen_v6.png'
import Canopy1ScreeniOS from '../../assets/v6/iOS Models/canopy 1 screen_v6.usdz'

import Canopy2Screen from '../../assets/v6/Android Models/canopy 2 screens_v6.glb'
import Canopy2ScreenPng from '../../assets/v6/PNGs/canopy 2 screens_v6.png'
import Canopy2ScreeniOS from '../../assets/v6/iOS Models/canopy 2 screens_v6.usdz'

import Canopy3Screen from '../../assets/v6/Android Models/canopy 3 screens_v6.glb'
import Canopy3ScreenPng from '../../assets/v6/PNGs/canopy 3 screens_v6.png'
import Canopy3ScreeniOS from '../../assets/v6/iOS Models/canopy 3 screens_v6.usdz'

import CanopyV1Screen from '../../assets/v6/Android Models/canopy 1 screen_post_v6.glb'
import CanopyV1ScreenPng from '../../assets/v6/PNGs/canopy 1 screen_post_v6.png'
import CanopyV1ScreeniOS from '../../assets/v6/iOS Models/canopy 1 screen_post_v6.usdz'

import CanopyV2Screen from '../../assets/v6/Android Models/canopy 2 screens_post_v6.glb'
import CanopyV2ScreenPng from '../../assets/v6/PNGs/canopy 2 screens_post_v6.png'
import CanopyV2ScreeniOS from '../../assets/v6/iOS Models/canopy 2 screens_post_v6.usdz'

import CanopyV3Screen from '../../assets/v6/Android Models/canopy 3 screens_post_v6.glb'
import CanopyV3ScreenPng from '../../assets/v6/PNGs/canopy 3 screens_post_v6.png'
import CanopyV3ScreeniOS from '../../assets/v6/iOS Models/canopy 3 screens_post_v6.usdz'

import Option2 from '../../assets/Images/drivethru.png'

import Option1 from '../../assets/v6/Android Models/new speaker post_v6.glb'
import Option1Png from '../../assets/v6/PNGs/new speaker post_v6.png'
import Option1ios from '../../assets/v6/iOS Models/new speaker post_v6.usdz'

import Screen1V1 from '../../assets/v6/Android Models/1_screen_post_v6.glb'
import Screen1V1iOS from '../../assets/v6/iOS Models/1_screen_post_v6.usdz'
import Screen1V1Png from '../../assets/v6/PNGs/1_screen_post_v6.png'

import Screen2V1Png from '../../assets/v6/PNGs/2_screen_post_v6.png'
import Screen2V1 from '../../assets/v6/Android Models/2_screen_post_v6.glb'
import Screen2V1ios from '../../assets/v6/iOS Models/2_screen_post_v6.usdz'

import Screen3V1 from '../../assets/v6/Android Models/3_screen_post_v6.glb'
import Screen3V1iOS from '../../assets/v6/iOS Models/3_screen_post_v6.usdz'
import Screen3V1Png from '../../assets/v6/PNGs/3_screen_post_v6.png'

const models = [
  {
    id: 0,
    androidModel: Option1,
    iosModel: Option1ios,
    poster: Option1Png
  },
  {
    id: 1,
    androidModel: Screen2,
    iosModel: Screen2iOS,
    poster: Screen2Png
  },
  {
    id: 2,
    androidModel: Screen2V1,
    iosModel: Screen2V1ios,
    poster: Screen2V1Png
  },
  {
    id: 3,
    androidModel: Canopy1Screen,
    iosModel: Canopy1ScreeniOS,
    poster: Canopy1ScreenPng
  },
  {
    id: 4,
    androidModel: Canopy2Screen,
    iosModel: Canopy2ScreeniOS,
    poster: Canopy2ScreenPng
  },
  {
    id: 5,
    androidModel: Canopy3Screen,
    iosModel: Canopy3ScreeniOS,
    poster: Canopy3ScreenPng
  },
  {
    id: 6,
    androidModel: Screen1,
    iosModel: Screen1iOS,
    poster: Screen1Png
  },
  {
    id: 7,
    androidModel: Option2,
    iosModel: Option2,
    poster: Option2
  },
  {
    id: 8,
    androidModel: Screen3,
    iosModel: Screen3iOS,
    poster: Screen3Png
  },
  {
    id: 9,
    androidModel: Screen1V1,
    iosModel: Screen1V1iOS,
    poster: Screen1V1Png
  },
  {
    id: 10,
    androidModel: CanopyV1Screen,
    iosModel: CanopyV1ScreeniOS,
    poster: CanopyV1ScreenPng
  },
  {
    id: 11,
    androidModel: CanopyV2Screen,
    iosModel: CanopyV2ScreeniOS,
    poster: CanopyV2ScreenPng
  },
  {
    id: 12,
    androidModel: CanopyV3Screen,
    iosModel: CanopyV3ScreeniOS,
    poster: CanopyV3ScreenPng
  },
  {
    id: 13,
    androidModel: Screen3V1,
    iosModel: Screen3V1iOS,
    poster: Screen3V1Png
  }
]

export default models
